import {
  REPLACE_ACCOUNT_INTEGRATIONS,
  REMOVE_INTEGRATION_AND_FLUSH_INTEGRATION,
  ACTIVATE_INTEGRATION_AND_FLUSH_INTEGRATION,
} from 'constants/actionTypes';

export function replaceAccountIntegrations(firebaseType, integrations) {
  return {
    type: REPLACE_ACCOUNT_INTEGRATIONS,
    payload: { firebaseType, integrations },
  };
}

export function removeAndFlushIntegration(integrationId) {
  return {
    type: REMOVE_INTEGRATION_AND_FLUSH_INTEGRATION,
    payload: { integrationId },
  };
}

export function activateAndFlushIntegration(integrationId) {
  return {
    type: ACTIVATE_INTEGRATION_AND_FLUSH_INTEGRATION,
    payload: { integrationId },
  };
}
